import values from 'lodash/values';
import includes from 'lodash/includes';

import { CreditRange } from '@jerry-serverless/enums/credit_range';

export { CreditRange };

export const CREDIT_RANGE_TITLE = {
  [CreditRange.LessThan550]: 'Less than 550',
  [CreditRange.Between550and659]: '550 - 659',
  [CreditRange.Between660and750]: '660 - 750',
  [CreditRange.MoreThan750]: 'More than 750',
  [CreditRange.NotSure]: 'I am not sure',
} as const;

/**
 * Check if string value is in CreditRange enum.
 * For parsing out 'signupParams'
 * @param val
 */
export const isCreditRangeEnumValue = (val?: string | null): val is CreditRange => {
  return includes(values(CreditRange), val);
};
